/* FlexiVox · interacciones del tema (sin dependencias).
   Todo funciona sin JavaScript: esto solo mejora la experiencia.
   Módulos: tema claro/oscuro · cabecera · filtros de la tienda · ficha de producto ·
   preguntas frecuentes · copiar correo · carrito. */
(function () {
  'use strict';

  var FV = window.FV || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var norm = function (s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); };

  /* Formato de precio según la configuración de la tienda ({{amount_with_comma_separator}} €, etc.) */
  function formatMoney(cents) {
    var format = FV.moneyFormat || '{{amount_with_comma_separator}} €';
    var value = (Number(cents) || 0) / 100;
    var fmt = function (n, dec, thou, decSep) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* Aviso flotante */
  var toastTimer;
  function toast(html) {
    var el = $('[data-toast]');
    if (!el) return;
    el.innerHTML = html;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  /* 1. Tema claro / oscuro ---------------------------------------------- */
  function initTheme() {
    var root = document.documentElement;
    $$('[data-theme-toggle]').forEach(function (btn) {
      var sync = function () { btn.setAttribute('aria-pressed', root.getAttribute('data-theme') === 'dark' ? 'true' : 'false'); };
      sync();
      btn.addEventListener('click', function () {
        var dark = root.getAttribute('data-theme') !== 'dark';
        if (dark) root.setAttribute('data-theme', 'dark'); else root.removeAttribute('data-theme');
        try { localStorage.setItem('fv-theme', dark ? 'dark' : 'light'); } catch (e) {}
        sync();
      });
    });
  }

  /* 2. Cabecera: fondo al hacer scroll y menú móvil --------------------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    if (header.classList.contains('is-overlay')) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 24); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var toggle = $('[data-menu-toggle]', header);
    if (!toggle) return;
    var setOpen = function (open) {
      header.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    toggle.addEventListener('click', function () { setOpen(!header.classList.contains('is-open')); });
    $$('.fv-nav a', header).forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && header.classList.contains('is-open')) { setOpen(false); toggle.focus(); } });
    // El menú móvil se oculta solo al hacer scroll o al tocar fuera de él
    var openedAt = 0;
    toggle.addEventListener('click', function () { openedAt = window.scrollY; });
    window.addEventListener('scroll', function () {
      if (header.classList.contains('is-open') && Math.abs(window.scrollY - openedAt) > 40) setOpen(false);
    }, { passive: true });
    document.addEventListener('click', function (e) {
      if (header.classList.contains('is-open') && !header.contains(e.target)) setOpen(false);
    });
  }

  /* 3. Filtros de color de la tienda ------------------------------------ */
  function initShop() {
    $$('[data-shop]').forEach(function (shop) {
      var chips = $$('[data-filter]', shop);
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var f = chip.getAttribute('data-filter');
          chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          $$('.fv-card', shop).forEach(function (card) {
            var show = f === 'todos' || ((f === 'tubo' || f === 'tapon') ? card.getAttribute('data-kind') === f : card.getAttribute('data-color') === f);
            card.hidden = !show;
          });
          $$('[data-shop-group]', shop).forEach(function (g) {
            g.hidden = !$$('.fv-card', g).some(function (c) { return !c.hidden; });
          });
        });
      });
    });
  }

  /* 4. Ficha de producto ------------------------------------------------- */
  /* Título de la ficha en móvil: si cabe en una sola línea reduciendo un poco la letra (hasta 20 px), se ajusta; si es demasiado largo, se deja en dos líneas */
  function fitProductTitle() {
    var title = $('[data-product-title]');
    if (!title || !title.parentElement) return;
    title.style.fontSize = '';
    if (window.innerWidth >= 700) return;
    var have = title.parentElement.clientWidth;
    var full = parseFloat(window.getComputedStyle(title).fontSize);
    // Se mide el texto en una sola línea con una copia invisible, para no alterar el diseño de la página
    var probe = document.createElement('span');
    probe.textContent = title.textContent;
    probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;left:-9999px;top:0;';
    probe.style.font = window.getComputedStyle(title).font;
    probe.style.letterSpacing = window.getComputedStyle(title).letterSpacing;
    document.body.appendChild(probe);
    var need = probe.offsetWidth;
    document.body.removeChild(probe);
    if (!need || !have || need <= have) return;
    var size = Math.floor(full * have / need);
    if (size >= 20) title.style.fontSize = size + 'px';
  }

  function initProduct() {
    $$('[data-product-section]').forEach(function (section) {
      var dataEl = $('[data-product-json]', section);
      var form = $('[data-product-form]', section);
      if (!dataEl || !form) return;
      var data = JSON.parse(dataEl.textContent);
      var matchEl = $('[data-match]', section);
      var matchData = $('[data-match-variants]', section);
      var matchVariants = matchData ? JSON.parse(matchData.textContent) : [];
      var slides = $$('[data-slide]', section);
      var thumbs = $$('[data-thumb]', section);

      var counter = $('[data-gallery-count]', section);
      var mainBox = $('.fv-gallery__main', section);
      // Fotos que se pueden recorrer ahora (las del color elegido)
      function visibleIndexes() {
        if (!thumbs.length) return slides.map(function (s) { return s.getAttribute('data-slide'); });
        return thumbs.filter(function (t) { return !t.closest('li').hidden; }).map(function (t) { return t.getAttribute('data-thumb'); });
      }
      function currentIndex() {
        var a = $('.fv-gallery__slide.is-active', section);
        return a ? a.getAttribute('data-slide') : null;
      }
      function showSlide(index) {
        slides.forEach(function (s) {
          var on = s.getAttribute('data-slide') === String(index);
          s.classList.toggle('is-active', on);
          // Vídeos: solo se reproduce el de la diapositiva activa (sin sonido); los demás se pausan
          var vid = $('video', s);
          if (vid) {
            if (on) { vid.muted = true; var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
            else if (!vid.paused) vid.pause();
          }
        });
        thumbs.forEach(function (t) {
          var on = t.getAttribute('data-thumb') === String(index);
          t.setAttribute('aria-current', on ? 'true' : 'false');
          // En el móvil, la miniatura activa se mantiene a la vista
          if (on && window.innerWidth < 990 && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
        if (counter) {
          var list = visibleIndexes();
          counter.textContent = (list.indexOf(String(index)) + 1) + ' / ' + list.length;
          counter.hidden = list.length < 2;
        }
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(t.getAttribute('data-thumb')); }); });

      /* Deslizar la foto con el dedo: izquierda = siguiente, derecha = anterior.
         El gesto vertical se deja al navegador (touch-action: pan-y) para no bloquear el scroll. */
      if (mainBox && slides.length > 1) {
        var x0 = 0, y0 = 0, dx = 0, mode = null, active = null;
        mainBox.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; mode = null;
          active = $('.fv-gallery__slide.is-active', section);
        }, { passive: true });
        mainBox.addEventListener('touchmove', function (e) {
          if (!active || e.touches.length !== 1) return;
          var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
          if (!mode) {
            if (Math.abs(mx) > 8 && Math.abs(mx) > Math.abs(my)) mode = 'x';
            else if (Math.abs(my) > 8) mode = 'y';
          }
          if (mode === 'x') {
            dx = mx;
            active.style.transition = 'none';
            active.style.transform = 'translateX(' + dx * 0.6 + 'px)';
          }
        }, { passive: true });
        var end = function () {
          if (!active) return;
          active.style.transition = '';
          active.style.transform = '';
          if (mode === 'x' && Math.abs(dx) > 45) {
            var list = visibleIndexes();
            var i = list.indexOf(currentIndex());
            var next = (i + (dx < 0 ? 1 : -1) + list.length) % list.length;
            showSlide(list[next]);
          }
          active = null; mode = null; dx = 0;
        };
        mainBox.addEventListener('touchend', end);
        mainBox.addEventListener('touchcancel', end);
      }

      function filterGallery(color) {
        if (!thumbs.length) return;
        var items = thumbs.map(function (t) { return t.closest('li'); });
        var matches = items.filter(function (li) { return color && li.getAttribute('data-hay').indexOf(color) !== -1; });
        var visible = matches.length ? matches : items;
        items.forEach(function (li) { li.hidden = visible.indexOf(li) === -1; });
        showSlide($('[data-thumb]', visible[0]).getAttribute('data-thumb'));
      }

      function update(variantId, radio) {
        var v = data.variants.filter(function (x) { return String(x.id) === String(variantId); })[0];
        if (!v) return;
        var price = $('[data-price]', section);
        if (price) price.innerHTML = formatMoney(v.price) + (v.compare_at_price > v.price ? ' <s>' + formatMoney(v.compare_at_price) + '</s>' : '');
        var title = $('[data-product-title]', section);
        if (title) title.textContent = title.getAttribute('data-product-title') + ' ' + v.title;
        fitProductTitle();
        var label = $('[data-selected-label]', section);
        if (label) label.textContent = v.title + ' · ' + formatMoney(v.price);
        var specColor = $('[data-spec-color]', section);
        if (specColor) specColor.textContent = v.title;
        var add = $('[data-add]', form);
        var addLabel = $('[data-add-label]', form);
        if (add) add.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? FV.strings.addToCart : FV.strings.soldOut;
        filterGallery(radio ? radio.getAttribute('data-color') : '');

        var ci = data.colorIndex[String(v.id)];
        if (matchEl && ci) {
          var m = matchVariants.filter(function (x) { return x.ci === ci; })[0];
          if (m) {
            matchEl.href = m.url;
            var name = $('[data-match-name]', matchEl);
            if (name) name.textContent = name.getAttribute('data-match-name') + ' ' + m.title;
            var mp = $('[data-match-price]', matchEl);
            if (mp) mp.textContent = formatMoney(m.price);
            var img = $('.fv-match__img img', matchEl);
            if (img && m.image) { img.src = m.image; img.removeAttribute('srcset'); }
          }
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      $$('input[name="id"][type="radio"]', form).forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) update(r.value, r); });
      });

      /* Cantidad */
      var qty = $('input[name="quantity"]', form);
      $$('[data-qty]', form).forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, Math.min(99, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10)));
          qty.value = n;
        });
      });

      /* Añadir al carrito sin salir de la página (si falla, el formulario se envía normal) */
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var add = $('[data-add]', form);
        var err = $('[data-form-error]', form);
        if (err) err.hidden = true;
        if (add) add.setAttribute('aria-busy', 'true');
        fetch((FV.routes.cartAdd || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
          .then(function (r) {
            if (!r.ok) throw new Error(r.json.description || r.json.message || FV.strings.error);
            toast(FV.strings.added + ' · <a href="' + FV.routes.cart + '">' + FV.strings.viewCart + '</a>');
            refreshCartCount();
          })
          .catch(function (error) {
            if (err) { err.textContent = error.message || FV.strings.error; err.hidden = false; }
          })
          .then(function () { if (add) add.removeAttribute('aria-busy'); });
      });
    });
  }

  function refreshCartCount() {
    fetch((FV.routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        $$('[data-cart-link]').forEach(function (el) { el.setAttribute('aria-label', 'Carrito (' + cart.item_count + ')'); });
      })
      .catch(function () {});
  }

  /* 5. Preguntas frecuentes --------------------------------------------- */
  function initFaq() {
    var faq = $('[data-faq]');
    if (!faq) return;
    var items = $$('[data-qa]', faq);
    var groups = $$('[data-group]', faq);
    var cats = $$('[data-cat]', faq);
    var search = $('[data-faq-search]', faq);
    var empty = $('[data-faq-empty]', faq);
    var state = { cat: 'todas', q: '' };

    function apply() {
      var q = norm(state.q).trim();
      var counts = { todas: 0 };
      groups.forEach(function (g) {
        var gid = g.getAttribute('data-group');
        var shown = 0;
        $$('[data-qa]', g).forEach(function (it) {
          var match = !q || norm(it.textContent).indexOf(q) !== -1;
          if (match) { counts[gid] = (counts[gid] || 0) + 1; counts.todas++; }
          var visible = match && (state.cat === 'todas' || state.cat === gid);
          it.hidden = !visible;
          if (visible) shown++;
          if (q && match) it.open = true;
        });
        g.hidden = shown === 0;
      });
      $$('[data-count]', faq).forEach(function (c) { c.textContent = counts[c.getAttribute('data-count')] || 0; });
      if (empty) empty.hidden = groups.some(function (g) { return !g.hidden; });
    }

    cats.forEach(function (b) {
      b.addEventListener('click', function () {
        state.cat = b.getAttribute('data-cat');
        cats.forEach(function (c) { c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
        apply();
      });
    });
    if (search) search.addEventListener('input', function () {
      state.q = search.value;
      if (state.q) { state.cat = 'todas'; cats.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-cat') === 'todas' ? 'true' : 'false'); }); }
      apply();
    });

    function openFromHash() {
      var id = decodeURIComponent(window.location.hash.slice(1));
      if (!id) return;
      var target = document.getElementById(id);
      if (target && target.matches('[data-qa]')) {
        target.open = true;
        setTimeout(function () { target.scrollIntoView({ block: 'start' }); }, 50);
      }
    }
    window.addEventListener('hashchange', openFromHash);
    openFromHash();
  }

  /* 6. Copiar correo ----------------------------------------------------- */
  function initCopy() {
    $$('[data-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var text = btn.getAttribute('data-copy');
        var done = function () { toast(FV.strings.copied); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done, function () { window.location.href = 'mailto:' + text; });
        } else {
          window.location.href = 'mailto:' + text;
        }
      });
    });
  }

  /* 7. Carrito: − / +, cantidad escrita y "Eliminar" --------------------
     Guarda en Shopify (/cart/update.js) y recarga para mostrar totales y descuentos exactos.
     Sin JavaScript: "Eliminar" es un enlace normal y hay un botón "Actualizar carrito". */
  function initCart() {
    var form = $('[data-cart-form]');
    if (!form) return;
    var wrap = form.closest('.fv-cart');
    var timer;
    function save(delay) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (wrap) wrap.classList.add('is-updating');
        var fd = new FormData(form);
        fd.delete('checkout');
        fetch((FV.routes.cart || '/cart') + '/update.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
          .then(function (r) { if (!r.ok) throw new Error(); window.location.reload(); })
          .catch(function () { form.submit(); });
      }, delay);
    }
    $$('[data-cart-qty]', form).forEach(function (input) {
      input.addEventListener('change', function () { save(300); });
    });
    $$('[data-cart-step]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = $('[data-cart-qty]', btn.closest('.fv-qty'));
        input.value = Math.max(0, Math.min(99, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-cart-step'), 10)));
        save(500);
      });
    });
  }

  /* 7b. Entrega en el carrito: a domicilio u oficina de Correos ---------
     El cliente elige la oficina en un mapa (Leaflet + OpenStreetMap, que se cargan solo si elige oficina)
     o en la lista. La oficina se guarda en los atributos del carrito y, al pulsar "Finalizar compra",
     el pago se abre con la dirección de envío rellenada con la de la oficina.
     Datos: assets/correos-oficinas.json → [código, nombre, domicilio, CP, localidad, provincia, lat, lng, horario]. */
  var LEAFLET = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/';
  function loadLeaflet() {
    if (window.L) return Promise.resolve(window.L);
    if (!loadLeaflet.p) {
      loadLeaflet.p = new Promise(function (resolve, reject) {
        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = LEAFLET + 'leaflet.min.css';
        document.head.appendChild(css);
        var s = document.createElement('script');
        s.src = LEAFLET + 'leaflet.min.js';
        s.onload = function () { resolve(window.L); };
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    return loadLeaflet.p;
  }

  function initShipChoice() {
    var box = $('[data-ship]');
    if (!box) return;
    var form = box.closest('form');
    var pick = $('[data-ship-pick]', box), q = $('[data-ship-q]', box), msg = $('[data-ship-msg]', box);
    var mapEl = $('[data-ship-map]', box), list = $('[data-ship-list]', box);
    var chosen = $('[data-ship-chosen]', box), chosenName = $('[data-ship-chosen-name]', box);
    var nameIn = $('[data-ship-name]', box), codeIn = $('[data-ship-code]', box);
    var extra = $('.fv-cart__extra', form), checkoutBtn = $('[name="checkout"]', form);
    var remind = $('[data-ship-remind]', form);
    // Texto del botón: "Finalizar compra" a domicilio (sin cambios) y el del ajuste "office_button" con oficina.
    var btnText = checkoutBtn && Array.prototype.filter.call(checkoutBtn.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); })[0];
    var btnHome = btnText ? btnText.textContent : '', btnOffice = box.getAttribute('data-ship-button') || btnHome;
    var data = null, map = null, layer = null;
    var cartUrl = (FV.routes && FV.routes.cart) || '/cart';

    function mode() {
      var r = $('[data-ship-mode]:checked', box);
      return r ? r.getAttribute('data-ship-mode') : 'home';
    }
    /* Carga las oficinas una sola vez y prepara el texto de búsqueda (sin tildes) de cada una. */
    function getData() {
      if (!data) {
        data = fetch(box.getAttribute('data-ship-src')).then(function (r) {
          if (!r.ok) throw new Error();
          return r.json();
        }).then(function (d) {
          d.loc = d.oficinas.map(function (o) { return norm(o[4]); });
          d.txt = d.oficinas.map(function (o, i) { return d.loc[i] + ' ' + norm(o[1] + ' ' + o[2]); });
          return d;
        });
        data.catch(function () { data = null; });
      }
      return data;
    }
    function saveAttrs() {
      return fetch(cartUrl + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: {
          'Entrega': mode() === 'office' ? 'Recogida en oficina de Correos' : 'A domicilio',
          'Oficina de Correos': nameIn.value,
          'Oficina de Correos - código': codeIn.value
        } })
      });
    }
    function label(o) { return o[1] + ' · ' + o[2] + ', ' + o[3] + ' ' + o[4]; }
    function dist(o, lat, lng) {
      var x = (o[7] - lng) * Math.cos((lat * Math.PI) / 180), y = o[6] - lat;
      return x * x + y * y;
    }
    function markerStyle(on) { return { weight: on ? 4 : 1, fillOpacity: on ? 1 : 0.7 }; }

    function choose(o) {
      nameIn.value = label(o);
      codeIn.value = o[0];
      chosenName.textContent = label(o);
      chosen.hidden = false;
      msg.textContent = '';
      $$('[data-ship-item]', list).forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-ship-item') === o[0]));
      });
      if (layer) {
        layer.eachLayer(function (m) { m.setStyle(markerStyle(m.options.code === o[0])); });
        map.panTo([o[6], o[7]]);
      }
      saveAttrs();
    }

    function render(found, d) {
      list.innerHTML = '';
      found.forEach(function (o) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fv-ship__item';
        b.setAttribute('data-ship-item', o[0]);
        b.setAttribute('aria-pressed', String(o[0] === codeIn.value));
        b.innerHTML = '<strong></strong><span></span><span class="fv-small"></span>';
        b.children[0].textContent = o[1];
        b.children[1].textContent = o[2] + ', ' + o[3] + ' ' + o[4];
        b.children[2].textContent = d.horarios[o[8]] || '';
        b.addEventListener('click', function () { choose(o); });
        li.appendChild(b);
        list.appendChild(li);
      });
      if (!found.length) return;
      mapEl.hidden = false;
      loadLeaflet().then(function (L) {
        if (!map) {
          map = L.map(mapEl, { scrollWheelZoom: false });
          L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          }).addTo(map);
          layer = L.layerGroup().addTo(map);
        }
        layer.clearLayers();
        var bounds = [];
        found.forEach(function (o) {
          var m = L.circleMarker([o[6], o[7]], Object.assign({ code: o[0], radius: 9, color: '#161616', fillColor: '#FFD200' }, markerStyle(o[0] === codeIn.value)));
          m.bindTooltip(o[1]);
          m.on('click', function () { choose(o); });
          layer.addLayer(m);
          bounds.push([o[6], o[7]]);
        });
        map.invalidateSize();
        map.fitBounds(bounds, { padding: [24, 24], maxZoom: 15 });
      }).catch(function () { mapEl.hidden = true; });
    }

    function search() {
      var text = String(q.value || '').trim();
      if (text.length < 2) { msg.textContent = 'Escribe un código postal o el nombre de tu ciudad.'; return; }
      msg.textContent = 'Buscando oficinas…';
      getData().then(function (d) {
        var all = d.oficinas, base;
        if (/^\d{5}$/.test(text)) {
          // Código postal exacto; si no tiene oficina, las de la misma zona (3 y luego 2 primeras cifras).
          [5, 3, 2].some(function (n) {
            base = all.filter(function (o) { return o[3].slice(0, n) === text.slice(0, n); });
            return base.length;
          });
        } else {
          // Localidad exacta (también "PAMPLONA/IRUÑA"), luego que empiece igual, luego que la contenga.
          var t = norm(text);
          [
            function (i) { return d.loc[i].split('/').some(function (p) { return p.trim() === t; }); },
            function (i) { return d.loc[i].indexOf(t) === 0; },
            function (i) { return d.txt[i].indexOf(t) > -1; }
          ].some(function (test) {
            base = all.filter(function (o, i) { return test(i); });
            return base.length;
          });
          // Si el nombre se repite en varias provincias (p. ej. "Sevilla" y "Sevilla la Nueva"), la que más oficinas tiene.
          var byProv = {};
          base.forEach(function (o) { byProv[o[5]] = (byProv[o[5]] || 0) + 1; });
          var top = Object.keys(byProv).sort(function (a, b) { return byProv[b] - byProv[a]; })[0];
          base = base.filter(function (o) { return o[5] === top; });
        }
        if (!base.length) {
          render([], d);
          mapEl.hidden = true;
          msg.textContent = 'No hemos encontrado oficinas. Prueba con otro código postal (solo España peninsular).';
          return;
        }
        var lat = 0, lng = 0;
        base.forEach(function (o) { lat += o[6] / base.length; lng += o[7] / base.length; });
        var found = all.slice().sort(function (a, b) { return dist(a, lat, lng) - dist(b, lat, lng); }).slice(0, 12);
        msg.textContent = found.length + ' oficinas cerca. Toca una en el mapa o en la lista.';
        render(found, d);
      }).catch(function () { msg.textContent = 'No se han podido cargar las oficinas. Recarga la página.'; });
    }

    function apply(userChange) {
      var office = mode() === 'office';
      pick.hidden = !office;
      if (extra) extra.hidden = office;
      if (remind) remind.hidden = !office;
      if (btnText) btnText.textContent = office ? btnOffice : btnHome;
      if (!office) {
        nameIn.value = '';
        codeIn.value = '';
        chosen.hidden = true;
      } else {
        getData();
        if (map) setTimeout(function () { map.invalidateSize(); }, 50);
      }
      if (userChange) saveAttrs();
    }

    $$('[data-ship-mode]', box).forEach(function (r) {
      r.addEventListener('change', function () { apply(true); });
    });
    $('[data-ship-go]', box).addEventListener('click', search);
    q.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); search(); }
    });

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        if (mode() !== 'office') return;
        e.preventDefault();
        if (!codeIn.value) {
          msg.textContent = 'Elige una oficina de Correos en el mapa o en la lista para continuar.';
          pick.scrollIntoView({ behavior: 'smooth', block: 'center' });
          q.focus({ preventScroll: true });
          return;
        }
        checkoutBtn.disabled = true;
        Promise.all([saveAttrs(), getData()]).then(function (res) {
          var o = res[1].oficinas.filter(function (x) { return x[0] === codeIn.value; })[0];
          var p = [];
          if (o) {
            var add = function (k, v) { p.push(encodeURIComponent('checkout[shipping_address][' + k + ']') + '=' + encodeURIComponent(v)); };
            add('address1', o[2]);
            add('address2', 'Oficina de Correos ' + o[1] + ' (cód. ' + o[0] + ')');
            add('zip', o[3]);
            add('city', o[4]);
            add('province', o[5]);
            add('country', 'ES');
          }
          window.location.href = '/checkout' + (p.length ? '?' + p.join('&') : '');
        }).catch(function () { window.location.href = '/checkout'; });
      });
      // Al volver atrás desde el pago, el navegador puede restaurar la página con el botón desactivado.
      window.addEventListener('pageshow', function () { checkoutBtn.disabled = false; });
    }

    apply(false);
  }

  /* 7c. Carrito en móvil: Flexi (botón del chat) se aparta mientras el resumen (entrega y "Finalizar compra")
     está en pantalla, para no tapar las opciones; vuelve en cuanto ese bloque sale de la vista. */
  function initChatAway() {
    var summary = $('.fv-cart__summary');
    if (!summary || !('IntersectionObserver' in window) || !window.matchMedia) return;
    var mobile = window.matchMedia('(max-width: 899px)');
    var visible = false;
    function update() { document.documentElement.classList.toggle('fv-chat-away', visible && mobile.matches); }
    // Solo cuenta la franja inferior de la pantalla (donde está Flexi): el 40 % de abajo.
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      update();
    }, { rootMargin: '-60% 0px 0px 0px' }).observe(summary);
    if (mobile.addEventListener) mobile.addEventListener('change', update);
  }

  /* 8. Compra rápida en las tarjetas de producto ------------------------ */
  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-quick-add]');
      if (!form || !window.fetch) return;
      e.preventDefault();
      var btn = $('button', form);
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      fetch((FV.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error(r.json.description || r.json.message || FV.strings.error);
          toast(FV.strings.added + ' · <a href="' + FV.routes.cart + '">' + FV.strings.viewCart + '</a>');
          refreshCartCount();
          btn.classList.add('is-done');
          setTimeout(function () { btn.classList.remove('is-done'); }, 1800);
        })
        .catch(function (error) {
          var d = document.createElement('div'); d.textContent = error.message || FV.strings.error;
          toast(d.innerHTML);
        })
        .then(function () { btn.removeAttribute('aria-busy'); });
    });
  }

  /* 9. Carrusel continuo ("FlexiVox en el día a día") -------------------
     Avanza solo hacia la izquierda sin fin (las fotos van duplicadas y al llegar a la mitad
     se vuelve al principio sin que se note). Se puede arrastrar con el ratón o deslizar con el
     dedo o el trackpad; al soltar, sigue solo a los 2 s. Se para fuera de pantalla, con la
     pestaña oculta y si el visitante tiene activado "reducir movimiento". */
  function initMarquee() {
    $$('[data-marquee]').forEach(function (track) {
      var list = track.firstElementChild;
      if (!list) return;
      var speed = parseFloat(track.getAttribute('data-speed')) || 40; // px por segundo
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var pos = 0, last = 0, inView = true, idleUntil = 0, dragging = false, moved = false, startX = 0, startPos = 0;
      var half = function () { return list.scrollWidth / 2; };
      var wrap = function () {
        var h = half();
        if (h <= 0) return;
        if (pos >= h) pos -= h;
        if (pos < 0) pos += h;
      };
      var pause = function (ms) { idleUntil = performance.now() + (ms || 2000); };

      function frame(now) {
        var dt = last ? Math.min(now - last, 64) / 1000 : 0;
        last = now;
        if (!reduced && inView && !dragging && !document.hidden && now > idleUntil) {
          pos += speed * dt;
          wrap();
          track.scrollLeft = pos;
        }
        requestAnimationFrame(frame);
      }

      // Si el usuario desplaza (dedo, trackpad, rueda), se toma su posición y se hace el bucle
      track.addEventListener('scroll', function () {
        if (Math.abs(track.scrollLeft - pos) > 2) {
          pos = track.scrollLeft;
          var before = pos;
          wrap();
          if (pos !== before) track.scrollLeft = pos;
          pause();
        }
      }, { passive: true });
      track.addEventListener('touchstart', function () { pause(4000); }, { passive: true });
      track.addEventListener('touchend', function () { pause(2000); }, { passive: true });
      track.addEventListener('wheel', function () { pause(2000); }, { passive: true });

      // Arrastrar con el ratón
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true; moved = false; startX = e.clientX; startPos = pos;
        track.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        pos = startPos - dx;
        wrap();
        track.scrollLeft = pos;
      });
      window.addEventListener('pointerup', function () {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        pause(2000);
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

      // Teclado: flechas para moverse
      track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var tile = list.firstElementChild;
        pos += (e.key === 'ArrowRight' ? 1 : -1) * (tile ? tile.getBoundingClientRect().width + 8 : 300);
        wrap();
        track.scrollTo({ left: pos, behavior: 'smooth' });
        pause(4000);
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; }).observe(track);
      }
      requestAnimationFrame(frame);
    });
  }

  /* 9b. Collage "FlexiVox en tus sesiones de canto" ---------------------
     Cuatro carriles (dos columnas y dos filas) que se mueven solos, cada uno a su ritmo. Aleatoriedad controlada:
     cada 4,5-9 s cada carril cambia de velocidad (0,6-1,4 veces la media; a veces una pausa corta) y el primero de
     cada pareja cambia de sentido de vez en cuando (como mucho ~20 s en el mismo); su pareja le sigue 0,6-2,6 s
     después, así las dos columnas (y las dos filas) casi siempre van en sentidos contrarios y se cruzan.
     Se arrastran con el ratón (y las filas con el dedo; las columnas dejan desplazar la página en móvil); al soltar
     siguen con la inercia y vuelven poco a poco a su ritmo. Con el ratón encima o el foco dentro, el carril se para.
     Para que el bucle no tenga cortes, cada carril se completa con copias (ocultas para lectores de pantalla).
     Al pulsar una foto o un vídeo se abre a pantalla completa: flechas, teclado (← →, Esc) o deslizar para pasar.
     Se para fuera de pantalla, con la pestaña oculta y con la pantalla completa abierta; con "reducir movimiento" no
     se mueve solo. Sin JavaScript, cada carril se desplaza a mano y los enlaces abren la foto o el vídeo. */
  function initCollage() {
    $$('[data-sing]').forEach(function (wall) {
      if (wall.__fvSing) return;
      wall.__fvSing = true;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var base = parseFloat(wall.getAttribute('data-speed')) || 28;
      var section = wall.parentElement;
      var rnd = function (a, b) { return a + Math.random() * (b - a); };
      var items = $$('[data-sing-tile]', wall).sort(function (a, b) { return a.getAttribute('data-i') - b.getAttribute('data-i'); });
      var FACTOR = [0.8, 1.05, 1, 0.85];
      var lanes = $$('[data-sing-lane]', wall).map(function (el, k) {
        var track = $('[data-sing-track]', el);
        var tiles = $$('[data-sing-tile]', track);
        if (!tiles.length) return null;
        return { el: el, track: track, tiles: tiles, k: k, vert: k < 2, pos: 0, v: 0, set: 0, dir: 1, mag: 1, dirSince: 0, nextAt: 0, flipAt: 0, idleUntil: 0, hold: 0, focusHold: false, still: false, drag: false, blockClick: false };
      }).filter(Boolean);
      if (!lanes.length) return;
      lanes.forEach(function (L) {
        L.partner = lanes.filter(function (o) { return o !== L && (o.k >> 1) === (L.k >> 1); })[0] || null;
        L.leads = !L.partner || L.k % 2 === 0;
      });
      lanes.forEach(function (L) {
        if (L.leads) L.dir = Math.random() < 0.5 ? 1 : -1;
        else L.dir = -L.partner.dir;
        L.mag = rnd(0.7, 1.3);
        L.v = base * FACTOR[L.k] * L.mag * L.dir;
        L.nextAt = performance.now() + rnd(2500, 7000);
        L.dirSince = performance.now();
      });

      var wrap = function (L) { if (L.set > 0) L.pos = ((L.pos % L.set) + L.set) % L.set; };
      var paint = function (L) {
        L.track.style.transform = L.vert ? 'translate3d(0,' + (-L.pos).toFixed(2) + 'px,0)' : 'translate3d(' + (-L.pos).toFixed(2) + 'px,0,0)';
      };

      // Vídeos del collage: sin sonido y solo los que se ven, como mucho 3 a la vez (2 en móvil) para no gastar datos;
      // con "ahorro de datos" se queda la portada. Se cargan al aparecer.
      var boxOpen = false;
      var conn = navigator.connection || {};
      var maxPlay = conn.saveData ? 0 : (window.matchMedia('(max-width: 749px)').matches ? 2 : 3);
      // Los que ya se están reproduciendo conservan su turno (así no se van alternando unos y otros al moverse)
      function syncVideos() {
        var vids = $$('video', wall), n = 0;
        vids.forEach(function (v) {
          if (!v.paused && (boxOpen || !v.__fvSeen)) v.pause();
          if (!v.paused) n++;
        });
        vids.forEach(function (v) {
          if (boxOpen || !v.__fvSeen || !v.paused || n >= maxPlay) return;
          n++;
          if (!v.getAttribute('src') && v.getAttribute('data-src')) v.setAttribute('src', v.getAttribute('data-src'));
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        });
      }
      var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.target.__fvSeen = en.isIntersecting; });
        syncVideos();
      }, { threshold: 0.35 }) : null;
      function watchVideos(root) { if (vio) $$('video', root).forEach(function (v) { vio.observe(v); }); }

      // Copias para el bucle: las justas para cubrir el carril más una vuelta. La longitud de una vuelta se mide con
      // decimales (de la primera foto a su primera copia): con medidas redondeadas el carril daba un saltito en cada vuelta.
      function layout(L) {
        $$('[data-sing-clone]', L.track).forEach(function (c) { if (vio) $$('video', c).forEach(function (v) { vio.unobserve(v); }); c.parentNode.removeChild(c); });
        var first = L.tiles[0], lastT = L.tiles[L.tiles.length - 1];
        var gap = parseFloat(getComputedStyle(L.track)[L.vert ? 'rowGap' : 'columnGap']) || 0;
        var approx = L.vert ? lastT.offsetTop + lastT.offsetHeight - first.offsetTop + gap : lastT.offsetLeft + lastT.offsetWidth - first.offsetLeft + gap;
        var size = L.vert ? L.el.clientHeight : L.el.clientWidth;
        L.set = 0;
        if (approx <= 0 || size <= 0) return;
        var copies = Math.ceil(size / approx) + 1;
        for (var c = 0; c < copies; c++) {
          L.tiles.forEach(function (t) {
            var n = t.cloneNode(true);
            n.setAttribute('data-sing-clone', '');
            n.setAttribute('aria-hidden', 'true');
            n.setAttribute('tabindex', '-1');
            n.removeAttribute('data-shopify-editor-block');
            $$('video', n).forEach(function (v) { v.removeAttribute('src'); });
            L.track.appendChild(n);
            watchVideos(n);
          });
        }
        var a = first.getBoundingClientRect(), b = L.track.children[L.tiles.length].getBoundingClientRect();
        L.set = L.vert ? b.top - a.top : b.left - a.left;
        L.el.scrollTop = 0; L.el.scrollLeft = 0;
        wrap(L); paint(L);
      }
      // Las fotos y vídeos tienen su proporción fijada desde el principio, así que solo hay que rehacerlo si cambia el tamaño
      var wallW = 0, wallH = 0;
      function layoutAll() {
        if (wall.clientWidth === wallW && wall.clientHeight === wallH) return;
        wallW = wall.clientWidth; wallH = wall.clientHeight;
        lanes.forEach(layout);
      }
      lanes.forEach(function (L) { watchVideos(L.track); });
      wall.classList.add('is-live');
      layoutAll();
      lanes.forEach(function (L) { L.pos = rnd(0, L.set); wrap(L); paint(L); });
      var rT;
      if ('ResizeObserver' in window) new ResizeObserver(function () { cancelAnimationFrame(rT); rT = requestAnimationFrame(layoutAll); }).observe(wall);

      // Ritmo de cada carril
      function plan(L, now) {
        if (L.leads) {
          var age = now - L.dirSince;
          if (age > 20000 || (age > 7000 && Math.random() < 0.45)) {
            L.dir = -L.dir; L.dirSince = now;
            if (L.partner) L.partner.flipAt = now + rnd(600, 2600);
          }
        }
        var pause = Math.random() < 0.12;
        L.mag = pause ? 0 : rnd(0.6, 1.4);
        L.nextAt = now + (pause ? rnd(1200, 2200) : rnd(4500, 9000));
      }

      var inView = true, last = 0;
      function frame(now) {
        var dt = last ? Math.min(now - last, 64) / 1000 : 0;
        last = now;
        if (inView && !boxOpen && !document.hidden) {
          lanes.forEach(function (L) {
            if (now >= L.nextAt) plan(L, now);
            if (L.flipAt && now >= L.flipAt) { L.flipAt = 0; L.dir = -L.dir; L.dirSince = now; }
            if (L.drag || L.set <= 0) return;
            var held = L.hold > 0 || L.focusHold;
            var target = (reduced || held || now < L.idleUntil) ? 0 : base * FACTOR[L.k] * L.mag * L.dir;
            // Con el ratón encima frena enseguida (0,35 s); el resto de cambios de ritmo son suaves (1,3 s)
            L.v += (target - L.v) * (1 - Math.exp(-dt / (held ? 0.35 : 1.3)));
            if (target === 0 && Math.abs(L.v) < 1) L.v = 0;
            if (L.v) { L.pos += L.v * dt; wrap(L); paint(L); }
            // El zoom al pasar el ratón solo con el carril quieto: en movimiento, las fotos que pasaban bajo el cursor
            // se acercaban y alejaban una tras otra y parecía que temblaban
            if (L.still !== !L.v) { L.still = !L.v; L.el.classList.toggle('is-still', L.still); }
          });
        }
        requestAnimationFrame(frame);
      }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { inView = en[0].isIntersecting; }).observe(wall);

      // Arrastrar, inercia, ratón encima, foco y trackpad
      lanes.forEach(function (L) {
        var down = false, moved = false, id = null, start = 0, startPos = 0, lastC = 0, lastT = 0, vel = 0;
        var coord = function (e) { return L.vert ? e.clientY : e.clientX; };
        L.el.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' ? e.button !== 0 : L.vert) return;
          down = true; moved = false; L.blockClick = false; id = e.pointerId;
          start = lastC = coord(e); startPos = L.pos; lastT = e.timeStamp; vel = 0;
        });
        L.el.addEventListener('pointermove', function (e) {
          if (!down || e.pointerId !== id) return;
          var c = coord(e), d = c - start;
          if (!moved && Math.abs(d) > 6) {
            moved = true; L.drag = true; L.el.classList.add('is-dragging');
            try { L.el.setPointerCapture(id); } catch (err) {}
          }
          if (!moved) return;
          L.pos = startPos - d; wrap(L); paint(L);
          var dt = e.timeStamp - lastT;
          if (dt > 0) vel = 0.7 * (-(c - lastC) / dt * 1000) + 0.3 * vel;
          lastC = c; lastT = e.timeStamp;
        });
        function up(e) {
          if (!down || e.pointerId !== id) return;
          down = false;
          if (moved) {
            L.blockClick = true;
            L.v = e.type === 'pointercancel' ? 0 : Math.max(-2400, Math.min(2400, e.timeStamp - lastT > 80 ? 0 : vel));
          }
          L.drag = false; L.el.classList.remove('is-dragging');
        }
        L.el.addEventListener('pointerup', up);
        L.el.addEventListener('pointercancel', up);
        L.el.addEventListener('click', function (e) { if (L.blockClick) { e.preventDefault(); e.stopPropagation(); L.blockClick = false; } }, true);
        L.el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') L.hold++; });
        L.el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse' && L.hold > 0) L.hold--; });
        // Foco con teclado: el carril se para y se coloca para enseñar la foto enfocada (el navegador lo habría desplazado
        // por su cuenta: se deshace ese desplazamiento). Con el ratón o el dedo no cuenta: al cerrar la pantalla completa
        // el foco vuelve a la foto y el carril se quedaba parado hasta tocar en otro sitio.
        L.el.addEventListener('focusin', function (e) {
          L.el.scrollTop = 0; L.el.scrollLeft = 0;
          var kb = true;
          try { kb = e.target.matches(':focus-visible'); } catch (err) {}
          if (!kb) return;
          L.focusHold = true;
          var t = e.target.closest('[data-sing-tile]');
          if (t) { L.pos = (L.vert ? t.offsetTop : t.offsetLeft) - 12; wrap(L); paint(L); }
        });
        L.el.addEventListener('focusout', function () { L.focusHold = false; });
        if (!L.vert) {
          L.el.addEventListener('wheel', function (e) {
            if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
            e.preventDefault();
            L.pos += e.deltaX; wrap(L); paint(L);
            L.v = 0; L.idleUntil = performance.now() + 1500;
          }, { passive: false });
        }
      });
      requestAnimationFrame(frame);

      // Pantalla completa
      var box = $('[data-sing-box]', section);
      if (!box || typeof box.showModal !== 'function') return;
      var stage = $('[data-sing-stage]', box), count = $('[data-sing-count]', box);
      var cur = 0;
      function show(i) {
        cur = (i + items.length) % items.length;
        var t = items[cur], el;
        stage.innerHTML = '';
        if (t.hasAttribute('data-video')) {
          el = document.createElement('video');
          el.controls = true; el.autoplay = true; el.playsInline = true; el.preload = 'auto';
          el.poster = t.getAttribute('data-poster') || '';
          el.src = t.getAttribute('href');
        } else {
          el = document.createElement('img');
          el.alt = t.getAttribute('data-alt') || '';
          el.src = t.getAttribute('href');
          el.draggable = false;
        }
        // Sin texto debajo (decisión del usuario): la descripción queda solo como texto alternativo de la foto
        stage.appendChild(el);
        count.textContent = (cur + 1) + ' / ' + items.length;
        var nx = items[(cur + 1) % items.length];
        if (!nx.hasAttribute('data-video')) { var pre = new Image(); pre.src = nx.getAttribute('href'); }
      }
      function open(i) {
        boxOpen = true;
        syncVideos();
        show(i);
        box.showModal();
        document.documentElement.classList.add('fv-sing-open');
      }
      // Al cerrar: se vacía, se desbloquea la página y el collage sigue. No basta con el evento "close" del diálogo
      // (en algunos navegadores no llega y el collage se quedaba parado): cada forma de cerrar llama a finish().
      function finish() {
        if (!boxOpen) return;
        boxOpen = false;
        stage.innerHTML = '';
        document.documentElement.classList.remove('fv-sing-open');
        syncVideos();
        last = 0;
      }
      function closeBox() { if (box.open) box.close(); finish(); }
      box.addEventListener('close', finish);
      box.addEventListener('cancel', function () { setTimeout(finish, 0); });
      wall.addEventListener('click', function (e) {
        var t = e.target.closest('[data-sing-tile]');
        if (!t) return;
        e.preventDefault();
        var i = items.findIndex(function (o) { return o.getAttribute('data-i') === t.getAttribute('data-i'); });
        open(i < 0 ? 0 : i);
      });
      $('[data-sing-close]', box).addEventListener('click', closeBox);
      $('[data-sing-prev]', box).addEventListener('click', function () { show(cur - 1); });
      $('[data-sing-next]', box).addEventListener('click', function () { show(cur + 1); });
      box.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(cur - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); show(cur + 1); }
        if (e.key === 'Escape') { e.preventDefault(); closeBox(); }
      });
      // Pulsar fuera de la foto cierra; deslizar a los lados pasa de foto
      var sx = null, sy = 0;
      stage.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
      stage.addEventListener('pointerup', function (e) {
        if (sx === null) return;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        sx = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { show(cur + (dx < 0 ? 1 : -1)); return; }
        if (e.target === stage && Math.abs(dx) < 6 && Math.abs(dy) < 6) closeBox();
      });
    });
  }

  /* 3b. Transición "Cómo funciona" → guía: al bajar, lo que queda de la sección de arriba se desvanece hasta llegar a la guía */
  function initHowReveal() {
    var how = $('.fv-how');
    if (!how || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var ebook = $('#ebook');
    var wrap = how.parentElement;
    // Detrás de la sección que se desvanece queda el mismo gris que el de la guía: así no se ve ningún corte
    if (ebook && wrap) wrap.style.backgroundColor = window.getComputedStyle(ebook).backgroundColor;
    var queued = false;
    function update() {
      queued = false;
      var vh = window.innerHeight;
      var bottom = how.getBoundingClientRect().bottom;
      var p = Math.min(1, Math.max(0, (vh * 0.75 - bottom) / (vh * 0.75)));
      how.style.setProperty('--how-o', (1 - p).toFixed(3));
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  }

  /* 3c. Contador: el número sube de 0 al valor al cargar la página, a la vez que se rellenan las estrellas */
  function initCountUp() {
    var els = $$('[data-count-to]');
    if (!els.length || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    els.forEach(function (el) {
      var to = parseFloat(el.getAttribute('data-count-to')) || 0;
      var delay = parseFloat(el.getAttribute('data-count-delay')) || 0;
      var dur = parseFloat(el.getAttribute('data-count-duration')) || 1500;
      el.textContent = '0';
      var t0 = null;
      function frame(now) {
        if (t0 === null) t0 = now;
        var p = Math.min(1, Math.max(0, (now - t0 - delay) / dur));
        el.textContent = String(Math.round(to * p));
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    });
  }

  /* 3d. Barra de valoración: al llegar a esa zona se llena y el número sube de 0 a la media, a la vez y a la misma velocidad */
  function initScoreBars() {
    var scores = $$('.fv-score--bar');
    if (!scores.length || !('IntersectionObserver' in window) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    scores.forEach(function (sc) {
      var num = $('[data-score-value]', sc), fill = $('[data-score-pct]', sc);
      if (!num || !fill) return;
      var to = parseFloat(num.getAttribute('data-score-value')) || 0;
      var pct = parseFloat(fill.getAttribute('data-score-pct')) || 0;
      var fmt = function (v) { return v.toFixed(1).replace('.', ','); };
      num.textContent = fmt(0);
      fill.style.width = '0%';
      var done = false;
      new IntersectionObserver(function (entries, obs) {
        if (done || !entries[0].isIntersecting) return;
        done = true; obs.disconnect();
        var t0 = null, dur = 1800;
        (function frame(now) {
          if (t0 === null) t0 = now;
          var p = Math.min(1, (now - t0) / dur);
          num.textContent = fmt(to * p);
          fill.style.width = (pct * p) + '%';
          if (p < 1) requestAnimationFrame(frame);
        })(performance.now());
      }, { threshold: 0.9 }).observe(sc);
    });
  }

  /* 3e. Guía paso a paso (móvil): la barra fija bajo el menú marca el paso que se está viendo */
  function initStepBar() {
    var bar = $('.fv-stepbar');
    var steps = $$('.fv-step');
    if (!bar || !steps.length) return;
    var dots = $$('.fv-stepbar__dot', bar), label = $('[data-stepbar-n]', bar);
    var current = -1, ticking = false;
    function update() {
      ticking = false;
      var line = window.innerHeight * 0.5, idx = 0;
      steps.forEach(function (s, i) { if (s.getBoundingClientRect().top <= line) idx = i; });
      if (idx === current) return;
      current = idx;
      if (label) label.textContent = String(idx + 1);
      dots.forEach(function (d, i) {
        d.classList.toggle('is-current', i === idx);
        d.classList.toggle('is-done', i < idx);
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* 3f. Cómo funciona: al llegar a la zona, foto, línea y pasos aparecen en cadena (sin JS o con "reducir movimiento" se ve todo directamente) */
  function initHowSteps() {
    var how = $('.fv-how');
    if (!how || !('IntersectionObserver' in window) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    how.classList.add('js-reveal');
    new IntersectionObserver(function (entries, obs) {
      if (!entries[0].isIntersecting) return;
      how.classList.add('is-in');
      obs.disconnect();
    }, { threshold: 0.25 }).observe(how);
  }

  /* 3g. Ficha: «Más opciones de pago» propio, bajo los sellos; abre el mismo selector que el enlace original de Shopify (oculto) */
  function initMorePay() {
    var mine = $('[data-more-pay]');
    if (!mine) return;
    function original() { return $('#more-payment-options-link'); }
    mine.addEventListener('click', function (e) {
      e.preventDefault();
      var o = original();
      if (o) o.click();
    });
    function check() { if (original()) { mine.classList.add('is-ready'); return true; } return false; }
    if (check()) return;
    var mo = new MutationObserver(function () { if (check()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  /* 3h. Beneficios: los iconos se animan al llegar a la zona (reloj: una vez; ondas, aire y controles: mientras se ven) */
  function initIconAnims() {
    var icons = $$('.fv-benefits .fv-iconcircle');
    if (!icons.length || !('IntersectionObserver' in window) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        en.target.classList.toggle('is-live', en.isIntersecting);
        if (en.isIntersecting) en.target.classList.add('is-in');
      });
    }, { threshold: 0.9 });
    icons.forEach(function (el) { io.observe(el); });
  }

  /* 3i. ¿Para quién?: las tarjetas entran en cadena al llegar a la zona (sin JS o con "reducir movimiento" se ven directamente) */
  function initWhoReveal() {
    var who = $('.fv-who');
    if (!who || !('IntersectionObserver' in window) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    who.classList.add('js-reveal');
    new IntersectionObserver(function (entries, obs) {
      if (!entries[0].isIntersecting) return;
      who.classList.add('is-in');
      obs.disconnect();
    }, { threshold: 0.2 }).observe(who);
  }

  /* 3j. Guía interactiva: entrada en cadena al llegar a la zona y movimiento suave mientras se ve (sin JS o con "reducir movimiento" se ve todo directamente) */
  function initEbookMotion() {
    var sec = $('#ebook');
    if (!sec || !('IntersectionObserver' in window) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    sec.classList.add('js-reveal');
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      if (en.isIntersecting) sec.classList.add('is-in');
      sec.classList.toggle('is-live', en.isIntersecting);
    }, { threshold: 0.2 }).observe(sec);
  }

  /* 3k. Cómo funciona: burbujas más reales. Nacen sobre todo abajo, suben con vaivén y crecen un poco; algunas explotan por el camino (con un aro que se expande) y otras llegan arriba */
  function initBubbles() {
    var box = $('[data-bubbles]');
    if (!box || !box.animate || !('IntersectionObserver' in window) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var live = 0, MAX = 34, timer = null;
    function rnd(a, b) { return a + Math.random() * (b - a); }
    function spawn() {
      if (live >= MAX || document.hidden) return;
      var W = box.clientWidth, H = box.clientHeight;
      if (!W || !H) return;
      // Tamaños: muchas pequeñas, pocas grandes
      var r = Math.random(), s = r < 0.55 ? rnd(6, 14) : r < 0.88 ? rnd(14, 26) : rnd(26, 42);
      var x = rnd(0, W - s), sway = rnd(6, 22) * (s > 24 ? 0.6 : 1), phase = rnd(0, 6.28), turns = rnd(1.5, 3);
      var full = Math.max(6000, (15 - s * 0.14) * 1000 * rnd(0.8, 1.25));
      var pops = Math.random() < 0.5;
      var end = pops ? rnd(0.25, 0.85) : 1;
      var dur = full * end;
      var total = pops ? dur + 150 : dur;
      var riseFrac = dur / total;
      var dist = H + s + 20;
      var el = document.createElement('span');
      el.className = 'fv-bub';
      el.style.width = el.style.height = s + 'px';
      el.style.left = x + 'px';
      box.appendChild(el);
      live++;
      var frames = [], n = 14, i, p, k;
      for (i = 0; i <= n; i++) {
        p = i / n;
        k = p * end;
        frames.push({
          offset: p * riseFrac,
          opacity: p < 0.04 ? p / 0.04 * 0.95 : 0.95,
          transform: 'translate3d(' + (Math.sin(phase + p * turns * 6.28) * sway).toFixed(1) + 'px,' + (-dist * k).toFixed(1) + 'px,0) scale(' + (0.8 + 0.35 * k).toFixed(3) + ')'
        });
      }
      var last = frames[frames.length - 1];
      var popX = Math.sin(phase + turns * 6.28) * sway;
      var popY = -dist * end;
      // El estallido: la burbuja se hincha y desaparece en un instante
      if (pops) frames.push({ offset: 1, opacity: 0, transform: last.transform.replace(/scale\([^)]*\)/, 'scale(1.7)') });
      var anim = el.animate(frames, { duration: total, easing: 'linear', fill: 'forwards' });
      anim.onfinish = function () { if (el.parentNode) el.parentNode.removeChild(el); live--; };
      if (pops) {
        // Aro que se expande donde explota
        setTimeout(function () {
          if (!el.parentNode) return;
          var ring = document.createElement('span');
          ring.className = 'fv-bub-ring';
          ring.style.width = ring.style.height = s + 'px';
          ring.style.left = (x + popX) + 'px';
          box.appendChild(ring);
          var ra = ring.animate([
            { opacity: 0.85, transform: 'translate3d(0,' + popY.toFixed(1) + 'px,0) scale(1)' },
            { opacity: 0, transform: 'translate3d(0,' + popY.toFixed(1) + 'px,0) scale(2.2)' }
          ], { duration: 420, easing: 'ease-out', fill: 'forwards' });
          ra.onfinish = function () { if (ring.parentNode) ring.parentNode.removeChild(ring); };
        }, dur);
      }
    }
    function start() {
      if (timer) return;
      for (var i = 0; i < 6; i++) setTimeout(spawn, i * 220);
      timer = setInterval(function () { spawn(); if (Math.random() < 0.45) spawn(); }, 420);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) start(); else stop(); }, { threshold: 0.05 }).observe(box.parentElement);
  }

  /* Botón del chat de Shopify Inbox: se sustituye su icono por Flexi y la etiqueta "Chat" por "Consulta a Flexi".
     El botón real sigue siendo el de Shopify (abre el chat y muestra los mensajes sin leer); solo se le cambia el aspecto
     con un <style> dentro de su shadow DOM. Si Shopify cambia su estructura, no se aplica nada y queda el botón original. */
  function initChatLauncher() {
    var cfg = window.FV && window.FV.chat;
    if (!cfg || !cfg.img) return;
    var tries = 0;
    var CLIP_REST = 'polygon(0% 0%,100% 0%,100% 79.5%,90% 79.5%,90% 77%,86.5% 77%,83.4% 76.8%,80.3% 76.4%,77.2% 75.9%,74.1% 75.7%,71% 75.9%,68% 76.6%,64.9% 77%,61.8% 77%,58.7% 76.6%,55.6% 75.9%,52.5% 75.7%,49.4% 75.7%,46.3% 76.1%,43.2% 76.8%,40.2% 77%,37.1% 76.8%,34% 76.4%,30.9% 75.9%,27.8% 75.7%,25.1% 75.5%,0% 75.5%)';
    var CLIP_FULL = 'polygon(0% 0%,100% 0%,100% 100%,90% 100%,90% 100%,86.5% 100%,83.4% 100%,80.3% 100%,77.2% 100%,74.1% 100%,71% 100%,68% 100%,64.9% 100%,61.8% 100%,58.7% 100%,55.6% 100%,52.5% 100%,49.4% 100%,46.3% 100%,43.2% 100%,40.2% 100%,37.1% 100%,34% 100%,30.9% 100%,27.8% 100%,25.1% 100%,0% 100%)';
    function css() {
      return '' +
        '.activator{background:transparent!important;border:0!important;box-shadow:none!important;padding:0!important;' +
        '-webkit-backdrop-filter:none!important;backdrop-filter:none!important;' +
        'width:auto!important;height:auto!important;min-width:0!important;min-height:0!important;position:relative!important;' +
        'flex-direction:column!important;align-items:center!important;gap:10px!important;' +
        'overflow:visible!important;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
        /* Solo con el chat cerrado: con el panel abierto Shopify oculta el botón (display:none) y no hay que impedirlo */
        ':host(:not([open])) .activator{display:flex!important}' +
        /* Al cerrar el chat, Shopify devuelve el foco al botón y el navegador dibuja un recuadro alrededor de Flexi: se quita
           (el foco se nota igualmente porque Flexi se muestra entero) */
        '.activator:focus,.activator:focus-visible{outline:none!important}' +
        '.activator__icon{display:none!important}' +
        '.activator__label{display:block!important;order:-1;position:relative;font-size:0!important;line-height:0!important;' +
        'background:var(--fv-chat-bg,#111);border-radius:999px;padding:9px 16px;box-shadow:none;' +
        'max-width:none!important;width:auto!important;white-space:nowrap}' +
        '.activator__label::before{content:' + JSON.stringify(cfg.label) + ';display:block;font:600 14px/1.2 Montserrat,system-ui,-apple-system,"Segoe UI",sans-serif;' +
        'color:var(--fv-chat-fg,#fff);letter-spacing:.01em}' +
        '.activator__label::after{content:"";position:absolute;left:50%;bottom:-6px;width:12px;height:12px;margin-left:-6px;' +
        'background:var(--fv-chat-bg,#111);transform:rotate(45deg);border-radius:2px}' +
        /* Flexi "se asoma": en reposo solo se ve la parte de arriba hasta la línea del agua de la botella (el recorte sigue su onda,
           así que la división queda natural en el dibujo) y flota con el margen de siempre. Al pasar el ratón (solo en dispositivos con ratón)
           o enfocar con teclado sube y se ve entero. En móvil el "entero" es abrir el chat, y al cerrarlo vuelve a la posición inicial.
           El recorte (polígono) tiene los mismos vértices en reposo y entero para poder animarse.
           Las coordenadas salen de medir la onda en flexi-chat.png (259x440). Sin animación de entrada, sin sombras ni difuminados. */
        '.activator-nudge{--cut:39px;bottom:calc(var(--shopify-chat-activator-offset) + var(--private-preview-bar-offset,0px) - var(--cut))!important;transition:bottom .3s ease}' +
        '.activator-nudge:has(.activator:focus-visible){--cut:0px}' +
        '@media (hover:hover){.activator-nudge:hover{--cut:0px}}' +
        '.activator{--fw:100px;--fh:170px}' +
        '.activator::after{content:"";display:block;width:var(--fw);height:var(--fh);background:url(' + JSON.stringify(cfg.img) + ') center bottom/contain no-repeat;' +
        '-webkit-clip-path:' + CLIP_REST + ';clip-path:' + CLIP_REST + ';transition:clip-path .3s ease,-webkit-clip-path .3s ease}' +
        '.activator:focus-visible::after{-webkit-clip-path:' + CLIP_FULL + ';clip-path:' + CLIP_FULL + '}' +
        '@media (hover:hover){.activator-nudge:hover .activator::after{-webkit-clip-path:' + CLIP_FULL + ';clip-path:' + CLIP_FULL + '}}' +
        '.activator__indicator{position:absolute!important;top:34px!important;right:-2px!important;left:auto!important;bottom:auto!important}' +
        '@media (max-width:640px){.activator-nudge{--cut:0px}.activator{--fw:76px;--fh:130px;gap:6px!important}' +
        '.activator__label{order:1;padding:6px 11px;margin-top:-30px;z-index:1;transition:margin-top .3s ease}' +
        '.activator-nudge:has(.activator:focus-visible) .activator__label{margin-top:0}' +
        '.activator__label::before{font-size:12px}' +
        '.activator__label::after{bottom:auto;top:-5px;width:10px;height:10px;margin-left:-5px}' +
        '.activator__indicator{top:24px!important}}' +
        '@media (max-width:640px) and (hover:hover){.activator-nudge:hover .activator__label{margin-top:0}}' +
        '@media (prefers-reduced-motion:reduce){.activator-nudge,.activator::after,.activator__label{transition:none}}';
    }
    function paintTheme(root) {
      var dark = document.documentElement.getAttribute('data-theme') === 'dark';
      var host = root.host;
      host.style.setProperty('--fv-chat-bg', dark ? '#F5F2EF' : '#111111');
      host.style.setProperty('--fv-chat-fg', dark ? '#111111' : '#FFFFFF');
    }
    /* Shopify pinta primero un botón ligero directamente en el shadow DOM de <shopify-chat> y, más tarde, lo sustituye
       por <shopify-agent-runtime> (con su propio shadow DOM). Se estiliza cada uno de los dos en cuanto aparece. */
    function styleRoot(root) {
      var btn = root && root.querySelector && root.querySelector('button.activator');
      if (!btn) return;
      if (!root.getElementById('fv-chat-style')) {
        var st = document.createElement('style');
        st.id = 'fv-chat-style';
        st.textContent = css();
        root.appendChild(st);
        paintTheme(root);
        if (window.MutationObserver) new MutationObserver(function () { paintTheme(root); }).observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
      }
      if (btn.getAttribute('aria-label') !== cfg.label) btn.setAttribute('aria-label', cfg.label);
      /* Al cerrar el chat Shopify devuelve el foco al botón y en móvil el dedo no "sale" de encima: se le quita el foco para que
         Flexi vuelva a su posición inicial (solo asoma) y no se quede entero. */
      var host = root.host;
      if (host && host.tagName === 'SHOPIFY-AGENT-RUNTIME' && !host.__fvClose && window.MutationObserver) {
        host.__fvClose = true;
        var wasOpen = host.hasAttribute('open');
        new MutationObserver(function () {
          var isOpen = host.hasAttribute('open');
          if (wasOpen && !isOpen) {
            [0, 120, 400].forEach(function (ms) {
              setTimeout(function () {
                var b = root.querySelector('button.activator');
                if (b && root.activeElement === b) b.blur();
                if (document.activeElement && document.activeElement.tagName === 'SHOPIFY-CHAT') {
                  try { document.activeElement.blur(); } catch (e) {}
                }
              }, ms);
            });
          }
          wasOpen = isOpen;
        }).observe(host, { attributes: true, attributeFilter: ['open'] });
      }
    }
    function apply() {
      var chat = document.querySelector('shopify-chat');
      var sr = chat && chat.shadowRoot;
      if (!sr) return;
      styleRoot(sr);
      var rt = sr.querySelector('shopify-agent-runtime');
      if (rt && rt.shadowRoot) styleRoot(rt.shadowRoot);
    }
    var timer = setInterval(function () {
      apply();
      if (++tries > 400) clearInterval(timer);
    }, 250);
  }

  /* Diagrama móvil con números tocables: el texto de cada punto solo se ve al pulsar su número (otro toque lo oculta) */
  function initDiagramPoints() {
    document.querySelectorAll('[data-dm-tap]').forEach(function (box) {
      var pts = [].slice.call(box.querySelectorAll('[data-dm-pt]'));
      var notes = [].slice.call(box.querySelectorAll('[data-dm-note]'));
      pts.forEach(function (p) {
        p.addEventListener('click', function () {
          var i = p.getAttribute('data-dm-pt');
          var wasOpen = p.getAttribute('aria-expanded') === 'true';
          pts.forEach(function (q) { q.setAttribute('aria-expanded', 'false'); });
          notes.forEach(function (n) { n.hidden = true; });
          if (wasOpen) return;
          p.setAttribute('aria-expanded', 'true');
          notes.forEach(function (n) { if (n.getAttribute('data-dm-note') === i) n.hidden = false; });
        });
      });
    });
  }

  /* Pop-up de creadores de contenido: sale a los N segundos de entrar en la web (contados desde la primera página de la visita),
     espera si hay otro diálogo abierto, el aviso de cookies a la vista o la persona está escribiendo, y al cerrarlo no vuelve
     a salir en X días; tras enviar la solicitud, nunca. Al volver del envío (o con un error) se abre directamente en su paso.
     Con ?creadores en la dirección se abre siempre (para revisarlo); en el editor de temas, al seleccionar la sección. */
  function initCreators() {
    var box = $('[data-creators]');
    if (!box || typeof box.showModal !== 'function') return;
    var KEY = 'fv-creators';
    var days = Number(box.getAttribute('data-days')) || 14;
    var delay = (Number(box.getAttribute('data-delay')) || 5) * 1000;
    var force = /[?&]creadores\b/.test(location.search);
    var posted = $('[data-crea-posted]', box);
    function read() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
    function store(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    /* Pantallas por las que se navega, en el orden de los puntos (las que no tienen contenido no se pintan) */
    var dots = $$('[data-crea-dot]', box);
    var order = dots.map(function (d) { return d.getAttribute('data-crea-dot'); });
    var nav = $('[data-crea-nav]', box);
    var prev = $('[data-crea-prev]', box);
    var next = $('[data-crea-next]', box);
    /* Se avanza en orden hasta el formulario: los puntos solo llevan a pantallas ya vistas o a la siguiente */
    var seen = 0;
    function setStep(step, focusTitle) {
      var from = order.indexOf(box.getAttribute('data-step'));
      var to = order.indexOf(step);
      if (to > seen) seen = to;
      dots.forEach(function (d, i) { d.disabled = i > seen + 1; });
      var dir = to < from ? 'prev' : 'next';
      var changed = box.getAttribute('data-step') !== step;
      box.setAttribute('data-step', step);
      $$('[data-crea-panel]', box).forEach(function (p) {
        var on = p.getAttribute('data-crea-panel') === step;
        p.hidden = !on;
        p.classList.remove('is-in-next', 'is-in-prev');
        if (on && changed && box.open) { void p.offsetWidth; p.classList.add('is-in-' + dir); }
      });
      if (nav) nav.hidden = to < 0;
      dots.forEach(function (d, i) { if (i === to) d.setAttribute('aria-current', 'step'); else d.removeAttribute('aria-current'); });
      var active = document.activeElement;
      if (prev) prev.disabled = to <= 0;
      if (next) next.disabled = to < 0 || to >= order.length - 1;
      box.scrollTop = 0;
      /* El foco va al titular de la nueva pantalla cuando se llega con un botón de dentro o el botón pulsado queda desactivado */
      if (focusTitle || (active && active.disabled)) {
        var title = $('[data-crea-panel="' + step + '"] .fv-crea__title', box);
        if (title) title.focus({ preventScroll: true });
      }
    }
    function go(delta, focusTitle) {
      var i = order.indexOf(box.getAttribute('data-step'));
      var j = i + delta;
      if (i < 0 || j < 0 || j >= order.length) return;
      setStep(order[j], focusTitle);
    }
    function open(step) {
      setStep(step);
      if (!box.open) box.showModal();
      document.documentElement.classList.add('fv-crea-open');
    }
    var closed = true;
    box.addEventListener('close', finish);
    function finish() {
      document.documentElement.classList.remove('fv-crea-open');
      if (closed) return;
      closed = true;
      if (box.getAttribute('data-step') === 'ok') store('done');
      else if (read() !== 'done') store('closed:' + Date.now());
    }
    function closeBox() { if (box.open) box.close(); finish(); }
    var autoDone = false;
    function show(step) { closed = false; autoDone = true; open(step); }

    $$('[data-crea-close]', box).forEach(function (b) { b.addEventListener('click', closeBox); });
    $$('[data-crea-to]', box).forEach(function (b) {
      b.addEventListener('click', function () { setStep(b.getAttribute('data-crea-to'), true); });
    });
    /* "Quiero colaborar" de la invitación: a la pantalla siguiente (no directamente al formulario) */
    $$('[data-crea-forward]', box).forEach(function (b) {
      b.addEventListener('click', function () { go(1, true); });
    });
    dots.forEach(function (d) { d.addEventListener('click', function () { setStep(d.getAttribute('data-crea-dot')); }); });
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    /* Flechas del teclado (fuera de los campos) y deslizar con el dedo */
    box.addEventListener('keydown', function (e) {
      if (/^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
      if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'ArrowLeft') go(-1);
    });
    var tx = null, ty = 0;
    box.addEventListener('touchstart', function (e) {
      tx = /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName) ? null : e.touches[0].clientX;
      ty = e.touches[0].clientY;
    }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (tx === null) return;
      var dx = e.changedTouches[0].clientX - tx;
      var dy = e.changedTouches[0].clientY - ty;
      tx = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? 1 : -1);
    });
    /* Clic fuera de la tarjeta (en el fondo oscuro) = cerrar */
    box.addEventListener('click', function (e) {
      if (e.target !== box) return;
      var r = box.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeBox();
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(box)) show('intro'); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(box)) closeBox(); });
      return;
    }
    /* Botón "Colabora con FlexiVox" (menú y pie) y enlaces a flexivox.es/#colabora: lo abren siempre, aunque se cerrara antes */
    $$('[data-crea-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); show('intro'); });
    });
    function fromHash() {
      if (location.hash !== '#colabora') return false;
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      show('intro');
      return true;
    }
    window.addEventListener('hashchange', fromHash);
    if (posted) {
      var ok = posted.getAttribute('data-crea-posted') === 'ok';
      if (ok) store('done');
      show(ok ? 'ok' : 'form');
      return;
    }
    if (fromHash()) return;
    if (!force) {
      var st = read();
      var m = /^closed:(\d+)$/.exec(st);
      if (st === 'done' || (m && Date.now() - Number(m[1]) < days * 864e5)) return;
    }
    var t0 = Date.now();
    try {
      t0 = Number(sessionStorage.getItem('fv-visit')) || t0;
      sessionStorage.setItem('fv-visit', String(t0));
    } catch (e) {}
    function busy() {
      if (document.hidden || $('dialog[open]')) return true;
      var a = document.activeElement;
      if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
      /* El aviso de cookies es position: fixed (offsetParent siempre es null): se mira si ocupa sitio */
      var banner = document.getElementById('shopify-pc__banner');
      return !!(banner && banner.getBoundingClientRect().height > 0);
    }
    function attempt() {
      if (autoDone) return;
      if (busy()) setTimeout(attempt, 2000); else show('intro');
    }
    setTimeout(attempt, force ? 600 : Math.max(800, delay - (Date.now() - t0)));
  }

  function init() {
    initCreators();
    initDiagramPoints();
    initChatLauncher();
    initBubbles();
    initEbookMotion();
    initWhoReveal();
    initIconAnims();
    initMorePay();
    initHowSteps();
    initStepBar();
    initScoreBars();
    initCountUp();
    fitProductTitle();
    window.addEventListener('resize', fitProductTitle);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitProductTitle);
    initMarquee();
    initCollage();
    initHowReveal();
    initQuickAdd();
    initTheme();
    initHeader();
    initShop();
    initProduct();
    initFaq();
    initCopy();
    initCart();
    initShipChoice();
    initChatAway();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
